export function TeamEmptyStateIcon() {
  return (
    <svg
      width="62"
      height="58"
      viewBox="0 0 62 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.2933 39.6631V36.9959C34.2933 35.5811 33.7033 34.2243 32.6531 33.2239C31.6029 32.2235 30.1785 31.6615 28.6933 31.6615H20.2933C18.8081 31.6615 17.3838 32.2235 16.3336 33.2239C15.2834 34.2243 14.6934 35.5811 14.6934 36.9959V39.6631M42.6933 39.663V36.9957C42.6924 35.8138 42.2794 34.6656 41.5192 33.7315C40.759 32.7974 39.6947 32.1302 38.4933 31.8347M34.2933 15.8314C35.4979 16.1252 36.5656 16.7925 37.328 17.7282C38.0904 18.6639 38.5043 19.8147 38.5043 20.9991C38.5043 22.1836 38.0904 23.3344 37.328 24.2701C36.5656 25.2057 35.4979 25.8731 34.2933 26.1669M30.0933 20.9926C30.0933 23.9387 27.5861 26.3271 24.4933 26.3271C21.4006 26.3271 18.8934 23.9387 18.8934 20.9926C18.8934 18.0465 21.4006 15.6582 24.4933 15.6582C27.5861 15.6582 30.0933 18.0465 30.0933 20.9926Z"
        stroke="#78716C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.4264 17.3691V27.8688M60.6935 22.619H50.1594"
        stroke="#78716C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.2071 10.1572C44.0759 4.45813 36.6134 0.90948 28.3434 1.00173C13.0727 1.17208 0.831483 13.6922 1.00187 28.9661C1.17225 44.2401 13.6897 56.484 28.9605 56.3136C40.9707 56.1796 51.1069 48.4066 54.805 37.6628"
        stroke="#78716C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />
    </svg>
  );
}
